import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    MatSnackBar,
    MatSnackBarConfig,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { DialogMsgComponent } from './dialog-msg/dialog-msg.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import {
    MessageAction,
    MessageObserverService,
} from '../../services/message-observer.service';
import { isEmpty } from '../../utils/utilsShared';

@Component({
    selector: 'lib-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.css'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent implements OnInit {
    setAutoHide = signal(true);
    autoHide = signal(2500);
    addExtraClass = signal(false);
    horizontalPosition = signal<MatSnackBarHorizontalPosition>('center');
    verticalPosition = signal<MatSnackBarVerticalPosition>('top');
    opnedDialog = signal(false);

    constructor(
        public dialog: MatDialog,
        private messageObserverService: MessageObserverService,
        public snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        //console.log('MessageComponent');

        this.messageObserverService.watchMessage().subscribe((value) => {
            if (isEmpty(value.message) || this.opnedDialog()) {
                return;
            }
            if (value.dialogRef) {
                this.dialog.closeAll();
            }

            //console.log(value, this.opnedDialog());

            if (value.dialog) {
                this.opnedDialog.set(true);
                const dy = this.dialog.open(DialogMsgComponent, {
                    data: {
                        message: value.message,
                        translate: value.translate,
                        title: value.title,
                        id: value.id,
                    },
                });
                if (value.dialogRef) {
                    this.messageObserverService.dialog = dy;
                }
                this.cdr.markForCheck();

                dy.afterClosed().subscribe((result) => {
                    this.opnedDialog.set(false);
                    this.cdr.markForCheck();
                });
            }
            if (value.snackBar) {
                this.opnedDialog.set(true);
                const snbk = this.snackBar.openFromComponent(
                    SnackBarComponent,
                    this._createConfig(value),
                );
                this.cdr.markForCheck();

                snbk.afterDismissed().subscribe((value) => {
                    //console.log(value);
                    this.opnedDialog.set(false);
                    this.cdr.markForCheck();
                });
            }
        });
    }

    private _createConfig(data: MessageAction) {
        const config = new MatSnackBarConfig();
        config.verticalPosition = this.verticalPosition();
        config.horizontalPosition = this.horizontalPosition();
        config.duration = this.setAutoHide() ? this.autoHide() : 0;
        // config.panelClass = this.addExtraClass ? ['demo-party'] : undefined;
        // config.direction = 500;
        config.panelClass = data.snackBar.panelClass || 'tw-snack-bar';
        config.data = data;
        if (data.snackBar && data.snackBar.duration) {
            config.duration = data.snackBar.duration;
        }
        ///console.log(data)
        return config;
    }
}
